import { AsPanel } from '../panels/as-panel.js';
import styleText from './as-step-panel.css?raw';

export class AsStepPanel extends AsPanel {
  static get observedAttributes() {
    return ['label-default-text', 'label-dict-key', 'disabled', 'hide', 'lock'];
  }

  private static _nextKey = 0;
  private readonly _busyKey = `step-panel-${AsStepPanel._nextKey++}`;

  attributeChangedCallback(name: string, _oldValue: string | null, newValue: string | null) {
    if (name === 'lock') {
      window.dispatchEvent(new CustomEvent('as-app-busy-request', {
        detail: { key: this._busyKey, busy: newValue !== null },
      }));
    }
  }

  private static readonly stepPanelSheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    if (this.shadowRoot) {
      this.shadowRoot.adoptedStyleSheets = [
        ...this.shadowRoot.adoptedStyleSheets,
        AsStepPanel.stepPanelSheet
      ];
    }
  }
}

if (!customElements.get('as-step-panel')) {
  customElements.define('as-step-panel', AsStepPanel);
} else {
  console.warn('as-step-panel already defined');
}
